
<template>
  <div class="container__stepper">
    <el-steps
      :active="active"
      finish-status="success"
      :align-center="true"
      class="steper"
    >
      <el-step
        title="1º"
        description="Estrutura do curso"
        icon="el-icon-guide"
      />
      <el-step
        title="2º"
        description="Dados de pagamento"
        icon="el-icon-bank-card"
      />
      <el-step
        title="3º"
        description="Informações do curso"
        icon="el-icon-edit"
      />
    </el-steps>
    <el-form v-if="active == 2" ref="form" :model="form">
      <div class="container-form">
        <el-form-item label="Nome">
          <el-input v-model="form.name" class="teste" />
        </el-form-item>

        <el-form-item label="Descrição">
          <el-input v-model="form.description" type="textarea" />
        </el-form-item>

        <el-form-item>
          <el-tag
            v-for="tag in tags"
            :key="tag"
            closable
            :disable-transitions="false"
            @close="closeTag(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            v-if="inputTagVisible"
            v-model="inputNewTag"
            class="input-new-tag"
            size="mini"
            @keyup.enter.native="addTag"
            @blur="addTag"
          />
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
          >
            + tags
          </el-button>
        </el-form-item>

        <el-form-item>
          <span class="demonstration">Período</span>
          <el-date-picker
            v-model="rangeDate"
            type="daterange"
            range-separator="até"
            start-placeholder="Data de ínicio"
            end-placeholder="Data de conclusão"
            class="date-range"
            format="dd/MM/yyyy"
          />
        </el-form-item>

        <el-form-item label="Banner">
          <el-upload
            ref="upload"
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary">
              Escolher arquivo
            </el-button>
            <el-button
              style="margin-left: 10px"
              size="small"
              type="success"
              @click="submitUpload"
            >
              Upload
            </el-button>
            <div slot="tip" class="el-upload__tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>
        </el-form-item>
      </div>
    </el-form>

    <el-form v-if="active == 1" ref="form" :model="form">
      <div class="container-form">
        <el-form-item>
          <span class="demonstration">Preço: </span>
          <el-input-number
            v-model="form.price"
            :precision="2"
            :step="0.1"
            :max="1000"
          />
        </el-form-item>

        <el-form-item label="Formas de Pagamento">
          <br />
          <el-checkbox-group v-model="form.paymentType">
            <el-checkbox label="Cartão" name="type" class="checkbox" />
            <el-checkbox label="TED" name="type" class="checkbox" />
            <el-checkbox label="PIX" name="type" class="checkbox" />
            <el-checkbox label="Boleto" name="type" class="checkbox" />
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-select
            v-if="form.paymentType[0] == 'Cartão'"
            v-model="form.creditCard"
            placeholder="Forma de pagamento"
          >
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <el-form v-if="active == 0" ref="form" :model="form">
      <div class="container-form">
        <ul class="list-modules">
          <template v-for="(item, index) in modulos">
            <li :key="index">
              <p class="title-module">
                Módulo {{ index + 1 }} - {{ item.name }}
              </p>
              <ul class="list-lessons">
                <template v-for="(subItem, subIndex) in item.lessons">
                  <li
                    v-if="subItem.moduleId === item.id"
                    :key="subIndex"
                    class="title-lesson"
                  >
                    {{ subItem.name }}

                    <div class="lesson-options">
                      <img
                        style="display: none"
                        src="@/assets/icons/menu/edit.svg"
                        alt="Botão para editar lição"
                        @click="editLesson(subItem)"
                      />

                      <el-button
                        circle
                        type="primary"
                        icon="el-icon-edit"
                        @click="editNameLesson(subItem, index)"
                      ></el-button>
                      <el-button
                        circle
                        type="danger"
                        icon="el-icon-delete"
                        @click="deleteLesson(subItem, index, subIndex)"
                      >
                      </el-button>
                      <el-button
                        circle
                        type="info"
                        icon="el-icon-document-add"
                        @click="editLesson(subItem)"
                      >
                      </el-button>
                    </div>
                  </li>
                </template>

                <li>
                  <el-button
                    v-if="!newLessonFlag"
                    type="success"
                    icon="el-icon-plus"
                    class="button-add-lesson"
                    @click="newLesson(index)"
                  >
                    Adicionar lição
                  </el-button>

                  <div v-if="editLessonFlag && index === selectedModule">
                    <div class="container-input">
                      <el-input
                        v-model="inputLesson"
                        placeholder="Edite uma Lição"
                      />
                      <el-button @click="updateLesson(index)">
                        Editar
                      </el-button>
                    </div>
                  </div>

                  <div v-if="newLessonFlag && index === selectedModule">
                    <div class="container-input">
                      <el-input
                        v-model="inputLesson"
                        placeholder="Adicione nova Lição"
                      />
                      <el-button @click="addLesson(index)"> Salvar </el-button>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </template>
        </ul>
        <div v-if="newModuleFlag" class="container-input">
          <el-input v-model="inputModule" placeholder="Adicione novo Módulo" />
          <el-button @click="addModule"> Salvar </el-button>
        </div>

        <el-button type="success" icon="el-icon-plus" @click="newModule">
          Adicionar Módulo
        </el-button>
      </div>
    </el-form>

    <div class="footer">
      <el-button v-if="active != 0" style="margin-top: 12px" @click="previous">
        Anterior
      </el-button>
      <el-button v-if="active != 2" style="margin-top: 12px" @click="next">
        Próximo
      </el-button>
      <el-button v-if="active == 2" style="margin-top: 12px" @click="returnTo">
        Finalizar
      </el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      course: null,
      rangeDate: [],
      modulos: [],
      form: {
        name: '',
        description: '',
        date1: '',
        date2: '',
        delivery: false,
        price: '',
        paymentType: [],
        resource: '',
        desc: '',
        creditCard: '1',
      },
      tags: [],
      newTag: '',
      inputTagVisible: false,
      inputNewTag: '',
      selectOptions: [
        {
          value: '1',
          label: 'à vista - até 1x no cartão',
        },
        {
          value: '2',
          label: 'parcelado - até 2x no cartão',
        },
        {
          value: '3',
          label: 'parcelado - até 3x no cartão',
        },
        {
          value: '4',
          label: 'parcelado - até 4x no cartão',
        },
      ],
      active: 0,
      course_id: '',
      newModuleFlag: false,
      newLessonFlag: false,
      editLessonFlag: false,
      inputModule: '',
      lessonData: [],
      inputLesson: '',
      selectedModule: '',
      lessonArray: [],
      enunciado: '',
      a1: '',
      a2: '',
      a3: '',
      a4: '',
      a5: '',
      value1: false,
      value2: false,
      value3: false,
      value4: false,
      value5: false,
    };
  },

  async created() {
    const data = await this.getData();
    this.course = data.courses[0].id;
    this.form.name = data.courses[0].name;
    this.form.description = data.courses[0].description;
    this.rangeDate = [data.courses[0].beginDate, data.courses[0].endDate];
    this.form.price = data.courses[0].price;
    this.form.paymentType = data.courses[0].paymentType.split(', ');

    console.log(data);
    data.modules.forEach((item) => {
      this.modulos.push({
        ...item,
        // lessons: data.lessons,
      });
    });
  },

  methods: {
    async getData() {
      const courseId = this.$route.params.id;
      const response = await axios.get(
        process.env.VUE_APP_API + '/courses/' + courseId
      );
      return response.data;
    },

    showInput() {
      this.inputTagVisible = true;
    },
    submitUpload() {
      console.log('To be implemented');
    },

    addModule() {
      this.modulos.push({ name: this.inputModule, lessons: [] });
      this.newModuleFlag = false;
    },

    newModule() {
      this.inputModule = '';
      this.newModuleFlag = true;
    },

    async addLesson(index) {
      this.modulos[index].lessons.push({
        name: this.inputLesson,
        moduleId: this.modulos[index].id,
      });
      await axios.post(process.env.VUE_APP_API + '/lessons', {
        name: this.inputLesson,
        moduleId: this.modulos[index].id,
        moduleLesson: this.modulos[index].id,
      });
      this.newLessonFlag = false;
    },
    async deleteLesson(subItem, index, subIndex) {
      console.log(index);
      console.log(subItem);
      console.log(subIndex);
      this.$confirm('Deseja apagar essa lição ?', 'Aviso', {
        confirmButtonText: 'Apagar',
        cancelButtonText: 'Cancelar',
        type: 'error',
      })
        .then(async () => {
          this.$message({
            type: 'success',
            message: 'Item apagado',
          });
          axios.delete(process.env.VUE_APP_API + '/lessons/' + subItem.id);
          // this.$router.go();
          this.modulos[index].lessons.splice(subIndex, 1);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Acão cancelada',
          });
        });
    },

    async updateLesson(index) {
      console.log(index);
      console.log(this.lessonData[0]);

      // this.modulos[index].
      await axios.patch(
        process.env.VUE_APP_API + '/lessons/' + this.lessonData[0].id,
        {
          name: this.inputLesson,
        }
      );
      this.lessonData.pop();
      this.editLessonFlag = false;
      this.$router.go();
    },

    newLesson(index) {
      this.inputLesson = '';
      this.newLessonFlag = true;
      this.selectedModule = index;
    },
    editNameLesson(si, index) {
      this.lessonData.push(si);
      this.inputLesson = si.name;
      this.editLessonFlag = true;
      this.selectedModule = index;
    },

    previous() {
      if (this.active-- < 0) this.active = 0;
    },

    next() {
      if (this.active++ > 2) this.active = 0;
    },

    editLesson(index) {
      const courseId = this.$route.params.id;
      // const courseId = this.$route.params.moduleId;
      this.$router.push(
        '/teacher/courses/' +
          courseId +
          '/' +
          index.moduleId +
          '/lesson/' +
          index.id
      );
      // this.$router.push({ name: 'lesson', params: { id: index.id } });
      console.log(index);
    },

    async saveCourse() {
      console.log(this.course);
      const course = {
        name: this.form.name,
        description: this.form.description,
        banner: '',
        beginDate: this.rangeDate[0],
        endDate: this.rangeDate[1],
        price: this.form.price,
        paymentType: this.form.paymentType.join(', '),
      };

      await axios.patch(
        process.env.VUE_APP_API + '/courses/' + this.course,
        course
      );

      if (this.modulos.length > 0) {
        this.modulos.forEach(async (modulo) => {
          if (!modulo.id) {
            const module = {
              courseId: this.course,
              name: modulo.name,
              description: modulo.description,
            };
            await axios.post(process.env.VUE_APP_API + '/modules', module);
          }
        });
      }
    },

    async returnTo() {
      await this.saveCourse();
      this.$router.push({ path: '/teacher/courses' });
    },
  },
};
</script>

<style lang="scss" scoped>
.container__stepper {
  width: 80%;
  margin: 20px auto;

  .steper {
    margin-bottom: 20px;
    background: #fff;
    box-shadow: 2px 2px 2px rgba(63, 63, 68, 0.15);
    padding: 40px;
  }

  .label {
    font-size: 20px;
  }

  .date-range {
    width: 100%;
  }

  .el-form {
    width: 100%;
    padding: 20px;
    background: #fff;
    box-shadow: 2px 2px 2px rgba(63, 63, 68, 0.15);
    font-size: 32px;
  }

  .list-modules {
    list-style: none;

    .title-module {
      text-transform: uppercase;
      font-size: 24px;
      line-height: 28px;
      font-weight: 700;
      color: rgba(58, 59, 63, 1);
      margin: 20px 0;
    }

    li {
      &:last-child {
        margin-bottom: 20px;
      }
    }

    .list-lessons {
      list-style: none;

      .title-lesson {
        font-size: 20px;
        font-weight: 400;
        line-height: 18px;
        color: rgba(102, 120, 138, 1);
        text-transform: inherit;
        display: flex;
        width: 100%;
        justify-content: space-between;

        .lesson-options {
          cursor: pointer;

          img {
            margin: -8px 10px;
          }
        }
      }

      li {
        padding-bottom: 2.375rem;
        border-left: 2px solid #2e3a59;
        position: relative;
        padding-left: 20px;

        &::before {
          content: '';
          width: 15px;
          height: 15px;
          background: #2e3a59;
          border: 1px solid #2e3a59;
          border-radius: 50%;
          position: absolute;
          left: -10px;
          top: 0px;
        }

        &:last-child {
          border: 0;
          padding-bottom: 0;
          height: 40px;
          position: relative;

          &::before {
            content: '';
            left: -8px;
          }
        }

        .button-add-lesson {
          position: absolute;
          top: -10px;
        }
      }
    }
  }

  .container-input {
    display: flex;
    width: 100%;
    max-width: 750px;
    margin: auto;
    gap: 10px;
    margin-bottom: 20px;
    position: relative;
    top: -10px;
  }

  .container-form {
    max-width: 750px;
    margin: auto;
    display: flex;
    flex-direction: column;

    .block {
      display: block;
    }
  }

  .footer {
    width: 100%;
    max-width: 750px;
    margin: auto;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.container_lesson {
  width: 100%;
  position: relative;

  .toolbox {
    position: absolute;
    top: 0;
    right: 0;
    transition: top 1.3s;
    background-color: white;
    border-radius: 20px;
    z-index: 100;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
    }

    li {
      padding: 20px;
      cursor: pointer;
      &:hover {
        background-color: lightgray;
        border-radius: 20px;
      }
      .custom-size {
        font-size: 2.5rem;
      }
    }
  }

  .lesson {
    width: 100%;

    .container__lesson {
      background: white;
      margin: 20px;
      border-radius: 20px;
      padding: 20px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      display: flex;
      justify-content: center;

      &.text {
        overflow: hidden;
        padding: 0;
        display: block;

        .ql-container.ql-snow {
          border: 0px solid #ccc;
        }
      }

      &.quiz {
        display: block;

        .question {
          margin-bottom: 20px;
        }

        .answer__container {
          display: flex;
          align-items: center;
          gap: 20px;
          padding: 10px 0;
        }
      }
    }
  }
}
</style>